'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parsePhoneNumber;

var _max = require('libphonenumber-js/max');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _countryCodes = require('./country-codes');

var _countryCodes2 = _interopRequireDefault(_countryCodes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Attempts to parse a string into a PhoneNumber instance
 * @param {string} number Phone number to parse
 * @param {string|array} countryCode A single or list of country codes against which
 *        the number should be validated.  If a list, each code will be used to attempt a parse.
 *        The first valid parsing result will be returned.
 *
 *        If not are provided, a default set of all supported country codes will be used
 */


function parsePhoneNumber(number) {
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _countryCodes2.default;
  if (typeof number !== 'string') return null;
  var selectedCodes = Array.isArray(countryCode) ? countryCode : [countryCode];
  var parsedNumber = void 0;
  selectedCodes.find(function (country) {
    parsedNumber = (0, _max.parsePhoneNumberFromString)(number, country);
    return !(0, _isEmpty2.default)(parsedNumber) && parsedNumber.isValid();
  });
  return parsedNumber;
}